import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../components/context/Auth";
import styles from "./ProductionDetails.module.css";
import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
import { formatDateTime, LastActionCell } from "../../Utils/Utils";
import ProductionFilters from "../../components/updatedComponents/Production/ProductionFilters";
import {
  ProductionDetailsStatus,
  warehousesData,
} from "../../components/updatedComponents/Production/utils";
import { useDispatch, useSelector } from "react-redux";
import {
  setFilter,
  setPagination,
} from "../../store/slices/production/ProductionDetailsSlice";
import SearchBar from "../../components/updatedComponents/FormComponents/SearchBar";
import { UpdateDrawer } from "../../components/updatedComponents/Production/ProductionDetails/UpdateDrawer";
import { ProgressBar } from "../../components/updatedComponents/Production/ProgressBar";
import ThreeDotMenu from "../../components/updatedComponents/Production/ThreeDotMenu";
import QueueEditModal from "../../components/updatedComponents/Production/QueueEditModal";
import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
import TextElement from "../../components/updatedComponents/FormComponents/TextElement";
import Button from "../../components/updatedComponents/Dealers/Button";
import { CancelIcon2, LeftArrow } from "../../components/icons/Icon";
import { TemplateDone } from "../../components/icons/Icon2";
import { ModalWrapper } from "../../exports";
import AcceptProductionModal from "../../components/updatedComponents/Production/ProductionDetails/AcceptProductionModal";
import DropDown from "../../components/updatedComponents/FormComponents/DropDown";

// ─── Dummy Data ───────────────────────────────────────────────────────────────
const orderData = {
  orderId: "PV-2026-0008",
  voucherId: 15,
  customerName: "Satyam Singh",
  companyName: "Sing Interior",
  priority: "Urgent",
  totalItems: 63,
  totalQty: 4350,
  totalWeight: 10005,
  totalCBM: 26.1,
  createdAt: "2026-06-11T10:30:00.000Z",
  // status: "Voucher",
  status: "In Production",
  machine: "Extruder 2",
  // status: "Ready For Dispatch",
};
const now = new Date();
const daysAgo = (d) => new Date(now - d * 24 * 60 * 60 * 1000);
const hoursAgo = (h) => new Date(now - h * 3600000).toISOString();

// const INITIAL_ITEMS = [
//   {
//     id: 1,
//     queueNo: "1/1",
//     itemCode: "SHD11",
//     productName: "SUPER HEAVY",
//     requiredQty: 100,
//     producedQty: 100,
//     pendingQty: 0,
//     warehouse: "Nadarganj",
//     machine: "Extruder 2",
//     status: "Completed",
//     updatedAt: hoursAgo(5),
//     qtyHistory: [],
//     voucherNo: "PV-2026-005",
//     createdAt: daysAgo(4),
//     customer: "Sunita Sharma / SS Homes",
//   },
//   {
//     id: 2,
//     queueNo: "1/2",
//     itemCode: "SHF1B",
//     productName: "SUPER HEAVY",
//     requiredQty: 100,
//     producedQty: 100,
//     pendingQty: 0,
//     warehouse: "Nadarganj",
//     machine: "Extruder 2",
//     status: "Completed",
//     updatedAt: hoursAgo(2),
//     qtyHistory: [],
//     voucherNo: "PV-2026-005",
//     createdAt: daysAgo(4),
//     customer: "Sunita Sharma / SS Homes",
//   },
//   {
//     id: 3,
//     queueNo: "1/3",
//     itemCode: "SHF6",
//     productName: "SUPER HEAVY",
//     requiredQty: 100,
//     producedQty: 0,
//     pendingQty: 100,
//     warehouse: "Nadarganj",
//     machine: "Extruder 2",
//     status: "Pending",
//     updatedAt: hoursAgo(4),
//     qtyHistory: [],
//     voucherNo: "PV-2026-005",
//     createdAt: daysAgo(4),
//     customer: "Sunita Sharma / SS Homes",
//   },
//   {
//     id: 4,
//     queueNo: "1/4",
//     itemCode: "SHF7",
//     productName: "SUPER HEAVY",
//     requiredQty: 100,
//     producedQty: 0,
//     pendingQty: 100,
//     warehouse: "Nadarganj",
//     machine: "Extruder 2",
//     status: "Pending",
//     updatedAt: hoursAgo(6),
//     qtyHistory: [],
//     voucherNo: "PV-2026-005",
//     createdAt: daysAgo(4),
//     customer: "Sunita Sharma / SS Homes",
//   },
//   {
//     id: 5,
//     queueNo: "1/5",
//     itemCode: "SHJ8",
//     productName: "SUPER HEAVY",
//     requiredQty: 100,
//     producedQty: 0,
//     pendingQty: 100,
//     warehouse: "Nadarganj",
//     machine: "Extruder 2",
//     status: "Pending",
//     updatedAt: hoursAgo(1),
//     qtyHistory: [],
//     voucherNo: "PV-2026-005",
//     createdAt: daysAgo(4),
//     customer: "Sunita Sharma / SS Homes",
//   },
//   {
//     id: 6,
//     queueNo: "1/6",
//     itemCode: "SHK13",
//     productName: "SUPER HEAVY",
//     requiredQty: 100,
//     producedQty: 0,
//     pendingQty: 100,
//     warehouse: "Nadarganj",
//     machine: "Extruder 2",
//     status: "Pending",
//     updatedAt: hoursAgo(8),
//     qtyHistory: [],
//     voucherNo: "PV-2026-005",
//     createdAt: daysAgo(4),
//     customer: "Sunita Sharma / SS Homes",
//   },
//   {
//     id: 7,
//     queueNo: "1/7",
//     itemCode: "SHK20",
//     productName: "SUPER HEAVY",
//     requiredQty: 100,
//     producedQty: 0,
//     pendingQty: 100,
//     warehouse: "Nadarganj",
//     machine: "Extruder 2",
//     status: "Pending",
//     updatedAt: hoursAgo(2),
//     qtyHistory: [],
//     voucherNo: "PV-2026-005",
//     createdAt: daysAgo(4),
//     customer: "Satyam Sharma / SS Homes",
//   },
//   {
//     id: 8,
//     queueNo: "1/8",
//     itemCode: "SHJ8",
//     productName: "SUPER HEAVY",
//     requiredQty: 100,
//     producedQty: 0,
//     pendingQty: 100,
//     warehouse: "Nadarganj",
//     machine: "Extruder 2",
//     status: "Pending",
//     updatedAt: hoursAgo(1),
//     qtyHistory: [],
//     voucherNo: "PV-2026-005",
//     createdAt: daysAgo(4),
//     customer: "Satyam Singh / SS Homes",
//   },
//   {
//     id: 9,
//     queueNo: "1/9",
//     itemCode: "SHK13",
//     productName: "SUPER HEAVY",
//     requiredQty: 100,
//     producedQty: 0,
//     pendingQty: 100,
//     warehouse: "Nadarganj",
//     machine: "Extruder 2",
//     status: "Pending",
//     updatedAt: hoursAgo(8),
//     qtyHistory: [],
//     voucherNo: "PV-2026-005",
//     createdAt: daysAgo(4),
//     customer: "Sunita Sharma / SS Homes",
//   },
//   {
//     id: 10,
//     queueNo: "1/10",
//     itemCode: "SHK20",
//     productName: "SUPER HEAVY",
//     requiredQty: 100,
//     producedQty: 0,
//     pendingQty: 100,
//     warehouse: "Nadarganj",
//     machine: "Extruder 2",
//     status: "Pending",
//     updatedAt: hoursAgo(2),
//     qtyHistory: [],
//     voucherNo: "PV-2026-005",
//     createdAt: daysAgo(4),
//     customer: "Sunita Sharma / SS Homes",
//   },
// ];

// ─── Main Component ───────────────────────────────────────────────────────────

const ORDER_WISE_ITEMS = [
  {
    id: 1,
    queueNo: "1/1",
    itemCode: "SHD11",
    productName: "SUPER HEAVY",
    requiredQty: 100,
    producedQty: 100,
    pendingQty: 0,
    warehouse: "Nadarganj",
    machine: "Extruder 2",
    status: "Completed",
    updatedAt: hoursAgo(5),
  },
  {
    id: 2,
    queueNo: "1/2",
    itemCode: "SHF1B",
    productName: "SUPER HEAVY",
    requiredQty: 100,
    producedQty: 75,
    pendingQty: 25,
    warehouse: "Nadarganj",
    machine: "Extruder 1",
    status: "In Production",
    updatedAt: hoursAgo(2),
  },
  {
    id: 3,
    queueNo: "1/3",
    itemCode: "SHF6",
    productName: "SUPER HEAVY",
    requiredQty: 100,
    producedQty: 0,
    pendingQty: 100,
    warehouse: "Amausi",
    machine: "Extruder 3",
    status: "Pending",
    updatedAt: hoursAgo(4),
  },
];

const MACHINE_WISE_ITEMS = [
  {
    id: 1,
    queueNo: "L1/1",
    itemCode: "SHD11",
    productName: "SUPER HEAVY",
    voucherNo: "PV-2026-005",
    createdAt: daysAgo(4),
    customer: "Sunita Sharma / SS Homes",
    requiredQty: 100,
    producedQty: 100,
    pendingQty: 0,
    status: "Completed",
    updatedAt: hoursAgo(5),
  },
  {
    id: 2,
    queueNo: "L1/2",
    itemCode: "SHF1B",
    productName: "SUPER HEAVY",
    voucherNo: "PV-2026-006",
    createdAt: daysAgo(3),
    customer: "Satyam Sharma / SS Homes",
    requiredQty: 100,
    producedQty: 75,
    pendingQty: 25,
    status: "In Production",
    updatedAt: hoursAgo(2),
  },
  {
    id: 3,
    queueNo: "L1/3",
    itemCode: "SHF6",
    productName: "SUPER HEAVY",
    voucherNo: "PV-2026-007",
    createdAt: daysAgo(2),
    customer: "Satyam Singh / SS Homes",
    requiredQty: 100,
    producedQty: 0,
    pendingQty: 100,
    status: "Pending",
    updatedAt: hoursAgo(4),
  },
];

const ProductionDetails = () => {
  const { orderId } = useParams();
  const { mode } = useAuth();
  const { show } = useToast();
  const navigate = useNavigate();

  const { filter } = useSelector((state) => state.productionDetails);
  const productionDetails = useDispatch(); // FIX: was incorrectly named "productionDetails"
  const location = useLocation();

  const activeTab = location.state?.tabType || "Order Wise";
  const status = location.state?.status;

  const [currentStatus, setCurrentStatus] = useState(
    location.state?.status || "Voucher",
  );

  const INITIAL_ITEMS =
    activeTab === "Order Wise" ? ORDER_WISE_ITEMS : MACHINE_WISE_ITEMS;

  const [items, setItems] = useState(INITIAL_ITEMS);
  const [selectedItem, setSelectedItem] = useState(null);
  const [queueEditItem, setQueueEditItem] = useState(null);
  const [modalContent, setModalContent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // FIX: statusCards now correctly passes label and status from config
  const statusCards = useMemo(() => {
    const config = ProductionDetailsStatus[activeTab] || [];
    return config.map((cfg) => ({
      status: cfg.status,
      label: cfg.label,
      count: cfg.countKey,
    }));
  }, [activeTab]);

  const [warehouses, setWarehouses] = useState([]);
  useEffect(() => {
    if (warehousesData) {
      setWarehouses(
        warehousesData.map((w) => ({
          label: w.warehousename,
          value: w.warehouseId,
        })),
      );
    }
  }, []);

  // Progress computed from live item state
  const totalRequired = items.reduce((s, i) => s + i.requiredQty, 0);
  const totalProduced = items.reduce((s, i) => s + i.producedQty, 0);
  const progressPct =
    totalRequired > 0 ? Math.round((totalProduced / totalRequired) * 100) : 0;

  const handleSave = ({ item, qty, machine, status }) => {
    setItems((prev) =>
      prev.map((row) => {
        if (row.id !== item.id) return row;

        const newProduced = row.producedQty + qty;
        const newPending = Math.max(row.requiredQty - newProduced, 0);

        const historyEntry = {
          qty,
          note: status,
          ts: new Date().toISOString(),
        };

        return {
          ...row,
          machine,
          status: newPending === 0 ? "Completed" : status,
          producedQty: newProduced,
          pendingQty: newPending,

          qtyHistory: [...(row.qtyHistory || []), historyEntry],
        };
      }),
    );
  };

  const openUpdateModal = (item) => {
    setSelectedItem(item);
  };

  // Confirms queue position change from QueueEditModal
  const handleQueueConfirm = (item, newPosition) => {
    setItems((prev) => {
      // Pull out the item being moved
      const moving = prev.find((r) => r.id === item.id);
      if (!moving) return prev;

      // const oldPosition = moving.queueNo;

      // Reorder: remove item, insert at new position
      const without = prev.filter((r) => r.id !== item.id);
      without.splice(newPosition - 1, 0, { ...moving, queueNo: newPosition });

      // Re-number all queueNo values sequentially
      return without.map((r, idx) => ({ ...r, queueNo: idx + 1 }));
    });
    show(`Queue updated to position ${newPosition}`);
    setQueueEditItem(null);
  };

  // Cancels an item from ThreeDotMenu
  const handleCancelItem = (it) => {
    if (
      window.confirm(
        `Cancel order for ${it.itemCode || it.orderId || it.machine}?`,
      )
    ) {
      setItems((prev) =>
        prev.map((r) => (r.id === it.id ? { ...r, status: "Cancelled" } : r)),
      );
      show("Order cancelled.");
    }
  };

  const currentOrder = { ...orderData, orderId: orderId || orderData.orderId };

  const headers =
    activeTab === "Order Wise"
      ? [
          "Queue",
          "Item No",
          "Product",
          "Required Qty",
          "Produced Qty",
          "Pending Qty",
          "Warehouse",
          "Production Line",
          "Progress",
          "Status",
          "Last Action",
        ]
      : [
          "Queue",
          "Item No",
          "Product",
          "Voucher & Date & Time",
          "Customer",
          "Required Qty",
          "Produced Qty",
          "Pending Qty",
          "Progress",
          "Status",
          "Last Action",
        ];
  const isNewVoucher = currentStatus === "Voucher";
  const inProduction = currentStatus === "In Production";
  const readyForDispatch = currentStatus === "Ready For Dispatch";

  const getStatusColor = () => {
    if (isNewVoucher) return "#4164e3";
    if (inProduction) return "#f79009";
    if (readyForDispatch) return "#12b76a";
    return "#646b88";
  };

  const gridColumns =
    activeTab !== "Order Wise"
      ? "0.7fr 0.7fr 1fr  1.4fr 1.3fr 0.9fr 0.9fr 0.9fr 1fr  1fr 0.7fr 0.8fr"
      : "0.7fr 1fr 1.2fr 0.9fr 0.9fr 0.9fr 1fr 1.1fr 1fr 1.3fr 1.3fr 0.8fr";

  const openModal = (content) => {
    setIsModalOpen(true);
    setModalContent(content);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalContent(null);
  };

  const openAcceptOrderModal = () => {
    openModal(
      <AcceptProductionModal
        heading={"Accept Production Voucher"}
        centerHeading={
          "Are you sure you want to accept this Production Voucher?"
        }
        targetWord={"Production Voucher"}
        handleSubmit={acceptVoucher}
        handleCloseModal={closeModal}
      />,
    );
  };

  const acceptVoucher = () => {
    setCurrentStatus("In Production");
  };

  const openReadyForDispatch = () => {
    openModal(
      <AcceptProductionModal
        heading={"Ready For Dispatch"}
        centerHeading={
          "Are you sure want to move this production voucher for Ready For Dispatch"
        }
        targetWord={"Ready For Dispatch"}
        handleSubmit={handleReadyForDispatch}
        handleCloseModal={closeModal}
      />,
    );
  };

  const handleReadyForDispatch = () => {
    setCurrentStatus("Ready For Dispatch");
  };

  return (
    <div
      className={`${styles.production} ${mode ? styles.production_dark : ""}`}
      style={{ paddingBottom: activeTab === "Order Wise" ? "80px" : "0px" }}
    >
      <ModalWrapper
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        noBtn
      >
        {modalContent}
      </ModalWrapper>

      <div className={styles.production_top}>
        {/* Top Tab Bar */}
        <div className={styles.production_top_left}>
          <TopTabBar
            text={`Production Voucher / ${
              activeTab === "Machine Wise" ? "Production Line Wise" : activeTab
            } / ${currentOrder.voucherId} `}
          />
        </div>

        <div className={styles.production_right}>
          <TextElement
            label={"Voucher No. & Date:"}
            labelColor={mode ? "#fff" : "#646B88"}
            value={
              currentOrder.orderId +
              " / " +
              formatDateTime(currentOrder.orderDate)
            }
            valueColor={mode ? "#fff" : "#646B88"}
            fontSize={"12px"}
            type={"order"}
          />
          <TextElement
            label={"Created By:"}
            labelColor={mode ? "#fff" : "#646B88"}
            value={currentOrder.createdBy}
            valueColor={mode ? "#fff" : "#646B88"}
            fontSize={"12px"}
            type={"order"}
          />

          <TextElement
            label={"Status:"}
            labelColor={mode ? "#fff" : "#646B88"}
            value={currentStatus}
            valueColor={getStatusColor(currentStatus)}
            fontSize={"12px"}
            type={"order"}
          />

          {/* <div className={styles.pegination}>
            <Pagination2
              mode={mode}
              currentPage={pagination.page}
              setCurrentPage={(newPage) =>
                productionDetails(setPagination({ page: newPage }))
              }
              totalPages={pagination.pages}
            />
          </div> */}
        </div>
      </div>

      {/* Header Card */}
      <div
        className={`${styles.production_header} ${
          mode ? styles.production_header_dark : ""
        }`}
      >
        {activeTab === "Order Wise" ? (
          <>
            <div>
              <p>Order Number: {orderId || currentOrder.voucherId}</p>
              <p>
                Customer: {currentOrder.customerName} /{" "}
                {currentOrder.companyName}
              </p>
              <p>Created At: {formatDateTime(currentOrder.createdAt)}</p>
            </div>

            <div className={styles.urgentBadge}>{currentOrder.priority}</div>
          </>
        ) : (
          <>
            <div>
              <p>Production Line: {currentOrder.machine}</p>
              <p>Production Id: MCH-005</p>
              <p>Warehouse: Burlington</p>
            </div>
            <div className={styles.urgentBadge}>In Production</div>
          </>
        )}
      </div>

      {/* Status Filter Cards */}
      <div
        className={styles.production_filters}
        style={
          mode ? { borderColor: "#232529", backgroundColor: "#232529" } : {}
        }
      >
        <ProductionFilters
          mode={mode}
          headerData={statusCards}
          selectedFilter={filter.selectedFilter}
          handleClick={(s) => {
            productionDetails(setFilter({ selectedFilter: s }));
            productionDetails(setPagination({ page: 1 }));
          }}
          type={"production"}
        />
      </div>

      {/* Search + Progress + Warehouse */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <SearchBar
          placeholder={"Search"}
          value={filter.keyword}
          onChange={(e) => {
            productionDetails(setFilter({ keyword: e.target.value }));
            productionDetails(setPagination({ page: 1 }));
          }}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "10px",
            flex: 1,
          }}
        >
          {/* Progress Bar */}
          <div className={styles.progressCard}>
            <div className={styles.progressHeader}>
              <span>Production Progress</span>
              <span>{progressPct}%</span>
            </div>
            <div className={styles.progressTrack}>
              <div
                className={styles.progressFill}
                style={{ width: `${progressPct}%` }}
              />
            </div>
          </div>

          {/* Warehouse Dropdown */}
          {activeTab === "Order Wise" && (
            <DropDown
              label={"Warehouse"}
              listLabel={"All"}
              options={warehouses}
              onSelect={(option) =>
                productionDetails(
                  setFilter({ selectedWarehouseId: option.value }),
                )
              }
              onReject={() =>
                productionDetails(setFilter({ selectedWarehouseId: null }))
              }
            />
          )}
        </div>
      </div>

      {/* Table */}
      <ul
        className={styles.productionTable}
        style={{ gridTemplateColumns: gridColumns }}
      >
        {/* Header */}
        <li
          className={styles.productionTableHeader}
          style={{ gridTemplateColumns: gridColumns }}
        >
          {headers.map((header, index) => (
            <div title={header} key={index}>
              {header}
            </div>
          ))}
        </li>

        {/* Rows */}
        {items.map((item) => (
          <li
            key={item.id}
            className={`${styles.productionTableRow} ${
              mode ? styles.productionTableRowDark : ""
            }`}
            style={{ gridTemplateColumns: gridColumns }}
          >
            <div title={item.queueNo}>{item.queueNo}</div>
            <div title={item.itemCode}>{item.itemCode}</div>
            <div title={item.productName}>{item.productName}</div>

            {activeTab !== "Order Wise" && (
              <>
                <div>
                  <div title={item.voucherNo}>{item.voucherNo}</div>
                  <div title={formatDateTime(item.createdAt)}>
                    {formatDateTime(item.createdAt)}
                  </div>
                </div>
                <div title={item.customer}>{item.customer}</div>
              </>
            )}

            <div title={item.requiredQty}>{item.requiredQty}</div>
            <div
              title={item.producedQty}
              style={{ color: "#12b76a", fontWeight: 600 }}
            >
              {item.producedQty}
            </div>
            <div
              title={item.pendingQty}
              style={{
                color: item.pendingQty > 0 ? "#f04438" : "#12b76a",
                fontWeight: 600,
              }}
            >
              {item.pendingQty}
            </div>
            {activeTab === "Order Wise" && (
              <div title={item.warehouse}>{item.warehouse}</div>
            )}

            {activeTab === "Order Wise" && (
              <div title={item.machine}>{item.machine}</div>
            )}

            <div style={{ width: "80%", paddingRight: 4 }}>
              <ProgressBar
                produced={item.producedQty}
                required={item.requiredQty || item.totalQty || 1}
                mode={mode}
              />
            </div>

            <div title={item.status}>
              {item.status === "Completed" ? (
                <span className={styles.completed}>Completed</span>
              ) : item.status === "In Production" ? (
                <span className={styles.inProduction}>In Production</span>
              ) : (
                <span className={styles.pending}>Pending</span>
              )}
            </div>

            <div title={item.updatedAt}>
              <LastActionCell lastAction={item.updatedAt} />
            </div>

            <div>
              <ThreeDotMenu
                item={item}
                mode={mode}
                onUpdate={() => openUpdateModal(item)}
                onQueueEdit={() => setQueueEditItem(item)}
                onCancel={() => handleCancelItem(item)}
              />
            </div>

            {/* <div>
              <button
                className={styles.updateBtn}
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedItem(item);
                }}
              >
                Update
              </button>
            </div> */}
          </li>
        ))}
      </ul>

      {activeTab === "Order Wise" && (
        <footer
          className={`${styles.footer} ${mode ? styles.footer_dark : ""}`}
        >
          <div>
            <TextElement
              label={"Total Items:"}
              labelColor={mode ? "#fff" : "#646B88"}
              value={items?.length}
              valueColor={mode ? "#fff" : "#646B88"}
              fontSize={"14px"}
              fontWeight={"400"}
            />
          </div>

          <div className={styles.btn_wrapper}>
            <div>
              <Button
                buttonIcon={<LeftArrow color={"#FFFFFF"} />}
                buttonText={"Back"}
                buttonBgColor={"#000000"}
                buttonTextColor={"#ffffff"}
                buttonClick={() => navigate(-1)}
              />
            </div>

            {inProduction && (
              <div>
                <Button
                  buttonIcon={<CancelIcon2 />}
                  buttonText={"Cancel"}
                  buttonBgColor={"#000000"}
                  buttonTextColor={"#ffffff"}
                  // buttonClick={openCancelOrderModal}
                />
              </div>
            )}

            {isNewVoucher && (
              <div>
                <Button
                  buttonIcon={<TemplateDone />}
                  buttonText={"Accept"}
                  buttonBgColor={"#4164E3"}
                  buttonTextColor={"#ffffff"}
                  buttonClick={openAcceptOrderModal}
                />
              </div>
            )}

            {inProduction && (
              <div>
                <Button
                  buttonIcon={<TemplateDone />}
                  buttonText={"Ready For Dispatch"}
                  buttonBgColor={"#4164E3"}
                  buttonTextColor={"#ffffff"}
                  buttonClick={openReadyForDispatch}
                />
              </div>
            )}

            {/* {readyForDispatch && (
              <div>
                <Button
                  buttonIcon={<SideBarDeliveryIcon color="#FFFFFF" />}
                  buttonText={"View Details"}
                  buttonBgColor={"#4164E3"}
                  buttonTextColor={"#ffffff"}
                  // buttonClick={handleReadyForDispatch}
                />
              </div>
            )} */}
          </div>
        </footer>
      )}

      {/* Update Drawer */}
      {selectedItem && (
        <UpdateDrawer
          setItems={setItems}
          item={selectedItem}
          mode={mode}
          onClose={() => setSelectedItem(null)}
          onSave={handleSave}
          selectedItem={selectedItem}
          activeTab={activeTab}
        />
      )}

      {queueEditItem && (
        <QueueEditModal
          item={queueEditItem}
          maxQueue={items.length}
          mode={mode}
          activeType={
            activeTab === "Machine Wise" ? "Production Line Wise" : activeTab
          }
          onConfirm={(newPosition) =>
            handleQueueConfirm(queueEditItem, newPosition)
          }
          onClose={() => setQueueEditItem(null)}
        />
      )}
    </div>
  );
};

export default ProductionDetails;
